import type { Content, StyleDictionary } from 'pdfmake/interfaces';
import { pdfTheme } from '../pdfTheme';
import type { BaseReportComponent } from './BaseReportComponent';
export const SUB_FORM_BORDER_WIDTH = 2;

export class SubForm implements BaseReportComponent {
	nodes: BaseReportComponent[] = [];

	constructor(
		private subFormTitle: string,
		private subFormSubTitle: string,
		content: BaseReportComponent[]
	) {
		this.nodes = [...content];
	}

	exportContent(): Content {
		return {
			layout: {
				hLineWidth: () => 0,
				vLineWidth: () => 0,
				hLineColor: () => pdfTheme.background.light,
				vLineColor: () => pdfTheme.background.light,
				paddingLeft: () => pdfTheme.spacing.large,
				paddingRight: () => 0,
				paddingTop: () => pdfTheme.spacing.default,
				paddingBottom: (i) => (i === 0 ? pdfTheme.spacing.default : 0),
			},
			style: ['subForm'],
			table: {
				widths: ['*'],
				body: [
					[
						{
							fillColor: pdfTheme.background.light,
							columnGap: 3,
							columns: [
								{
									text: `${this.subFormTitle}:`,
									width: 'auto',
									style: ['subFormTitle'],
								},
								{
									text: this.subFormSubTitle,
									style: ['subFormSubTitle'],
								},
							],
						},
					],
					[
						{
							stack: this.nodes.map((node) => node.exportContent()),
							marginLeft: pdfTheme.spacing.default,
						},
					],
				],
			},
		};
	}

	exportStyles(): StyleDictionary {
		return {
			subForm: {
				marginBottom: pdfTheme.spacing.small,
			},
			subFormTitle: {
				fontSize: pdfTheme.font.size.default,
				bold: true,
			},
			subFormSubTitle: {
				fontSize: pdfTheme.font.size.default,
			},
		};
	}
}
